import BuyerLayout from "../components/Layout";
import { useGetIdParam } from "../../SharedComponents/hooks/useGetIdParam";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getSingleRequest } from "../reduxStore/entities/userCars";
import { useEffect } from "react";
import PartRequestCardContainer from "../components/PartRequestComponents/Containers/PartRequestCardContainer";
import PartOffersTable from "../components/Tables/Table/PartOffersTable";
import PartRequestStateVisualizer from "../components/PartRequestComponents/Visualizers/PartRequestStateVisualizer";

const PartRequestSinglePage = () => {
    const idParam = useGetIdParam();
    const dispatch = useDispatch();

    const fetchedSingleRequest = useSelector((state) => state.userCars.singleRequest);
    const isLoaded = useSelector((state) => state.userCars.singleRequestLoaded);

    useEffect(() => {
        dispatch(getSingleRequest(idParam));
    }, [idParam]);

    if (!isLoaded) {
        return null;
    }

    const userCarBreadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: fetchedSingleRequest.UserCar?.title, href: `/garage/${fetchedSingleRequest.id_car_user}` },
        { title: fetchedSingleRequest.title },
    ];

    const getCarDescSubtitle = () => {
        return `${fetchedSingleRequest.Make.name} • ${fetchedSingleRequest.Model.name} • ${fetchedSingleRequest.Generation.name} • ${fetchedSingleRequest.Motor.name}`;
    };

    return (
        <BuyerLayout>
            <Breadcrumb
                title={fetchedSingleRequest.title}
                breadcrumbs={userCarBreadcrumbs}
                BesideTitleComponent={() => PartRequestStateVisualizer(fetchedSingleRequest.partstate)}
            />

            <div style={styles.requestInfoWrapper}>
                <div style={styles.sectionSpacing10}>
                    <PartRequestCardContainer
                        imageSrc={""}
                        title={fetchedSingleRequest.UserCar?.title}
                        subtitle={getCarDescSubtitle()}
                    />
                </div>

                <div style={styles.sectionSpacing10}>
                    <PartRequestCardContainer
                        imageSrc={""}
                        title={fetchedSingleRequest.title}
                        subtitle={fetchedSingleRequest.description}
                    />
                </div>

                <div style={styles.sectionSpacing20}>
                    {/* Dodatni sadržaj ako bude trebalo */}
                </div>
            </div>

            <div style={styles.sectionSpacing40}>
                <PartOffersTable partRequestId={idParam} />
            </div>
        </BuyerLayout>
    );
};

export default PartRequestSinglePage;

const styles = {
    requestInfoWrapper: {
        width: "60%",
    },
    sectionSpacing10: {
        marginTop: 10,
    },
    sectionSpacing20: {
        marginTop: 20,
    },
    sectionSpacing40: {
        marginTop: 40,
    },
};
